export enum PagesType {
  PRIVACY_POLICY = "PP",
  TERMS_AND_CONDITIONS = "TC",
  ABOUT = "AB",
  CUSTOMER_APP = "CA",
  MERCHANT_APP = "MA",
  MERCHANT_DASHBOARD = "MD",
}
